const BirthcontrolIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 50 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.18471 6.43247C6.40535 6.43247 4.98186 7.85596 4.98186 9.63532C4.98186 11.4147 6.40535 12.8382 8.18471 12.8382C9.96407 12.8382 11.3876 11.4147 11.3876 9.63532C11.3876 7.85596 9.96407 6.43247 8.18471 6.43247ZM8.18471 11.0588C7.384 11.0588 6.76122 10.436 6.76122 9.63532C6.76122 8.83461 7.384 8.21183 8.18471 8.21183C8.98542 8.21183 9.60819 8.83461 9.60819 9.63532C9.60819 10.436 8.98542 11.0588 8.18471 11.0588Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4142 6.43247C14.6349 6.43247 13.2114 7.85596 13.2114 9.63532C13.2114 11.4147 14.6349 12.8382 16.4142 12.8382C18.1936 12.8382 19.6171 11.4147 19.6171 9.63532C19.6171 7.85596 18.1491 6.43247 16.4142 6.43247ZM16.4142 11.0588C15.6135 11.0588 14.9908 10.436 14.9908 9.63532C14.9908 8.83461 15.6135 8.21183 16.4142 8.21183C17.215 8.21183 17.8377 8.83461 17.8377 9.63532C17.8377 10.436 17.1705 11.0588 16.4142 11.0588Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.3377 9.63532C30.3377 7.85596 31.7612 6.43247 33.5406 6.43247C35.3199 6.43247 36.7434 7.85596 36.7434 9.63532C36.7434 11.4147 35.3199 12.8382 33.5406 12.8382C31.7612 12.8382 30.3377 11.4147 30.3377 9.63532ZM32.1171 9.63532C32.1171 10.436 32.7399 11.0588 33.5406 11.0588C34.3413 11.0588 34.9641 10.436 34.9641 9.63532C34.9641 8.83461 34.3413 8.21183 33.5406 8.21183C32.7399 8.21183 32.1171 8.83461 32.1171 9.63532Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.7701 6.43247C39.9908 6.43247 38.5673 7.85596 38.5673 9.63532C38.5673 11.4147 39.9908 12.8382 41.7701 12.8382C43.5495 12.8382 44.973 11.4147 44.973 9.63532C44.973 7.85596 43.505 6.43247 41.7701 6.43247ZM41.7701 11.0588C40.9694 11.0588 40.3466 10.436 40.3466 9.63532C40.3466 8.83461 40.9694 8.21183 41.7701 8.21183C42.5708 8.21183 43.1936 8.83461 43.1936 9.63532C43.1936 10.436 42.5263 11.0588 41.7701 11.0588Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7972 9.63532C21.7972 7.85596 23.2206 6.43247 25 6.43247C26.7794 6.43247 28.2028 7.85596 28.2028 9.63532C28.2028 11.4147 26.7794 12.8382 25 12.8382C23.2206 12.8382 21.7972 11.4147 21.7972 9.63532ZM23.5765 9.63532C23.5765 10.436 24.1993 11.0588 25 11.0588C25.7562 11.0588 26.4235 10.436 26.4235 9.63532C26.4235 8.83461 25.8007 8.21183 25 8.21183C24.1993 8.21183 23.5765 8.83461 23.5765 9.63532Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.18471 14.7955C6.40535 14.7955 4.98186 16.2189 4.98186 17.9983C4.98186 19.7777 6.40535 21.2012 8.18471 21.2012C9.96407 21.2012 11.3876 19.7777 11.3876 17.9983C11.3876 16.2189 9.96407 14.7955 8.18471 14.7955ZM8.18471 19.4218C7.384 19.4218 6.76122 18.799 6.76122 17.9983C6.76122 17.1976 7.384 16.5748 8.18471 16.5748C8.98542 16.5748 9.60819 17.1976 9.60819 17.9983C9.60819 18.799 8.98542 19.4218 8.18471 19.4218Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2114 17.9983C13.2114 16.2189 14.6349 14.7955 16.4142 14.7955C18.1491 14.7955 19.6171 16.2189 19.6171 17.9983C19.6171 19.7777 18.1936 21.2012 16.4142 21.2012C14.6349 21.2012 13.2114 19.7777 13.2114 17.9983ZM14.9908 17.9983C14.9908 18.799 15.6135 19.4218 16.4142 19.4218C17.1705 19.4218 17.8377 18.8435 17.8377 18.0428C17.8377 17.2421 17.215 16.6193 16.4142 16.6193C15.6135 16.6193 14.9908 17.1976 14.9908 17.9983Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.5406 14.7955C31.7612 14.7955 30.3377 16.2189 30.3377 17.9983C30.3377 19.7777 31.7612 21.2012 33.5406 21.2012C35.3199 21.2012 36.7434 19.7777 36.7434 17.9983C36.7434 16.2189 35.3199 14.7955 33.5406 14.7955ZM33.5406 19.4218C32.7399 19.4218 32.1171 18.799 32.1171 17.9983C32.1171 17.1976 32.7399 16.5748 33.5406 16.5748C34.3413 16.5748 34.9641 17.1976 34.9641 17.9983C34.9641 18.799 34.3413 19.4218 33.5406 19.4218Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M38.5673 17.9983C38.5673 16.2189 39.9908 14.7955 41.7701 14.7955C43.505 14.7955 44.973 16.2189 44.973 17.9983C44.973 19.7777 43.5495 21.2012 41.7701 21.2012C39.9908 21.2012 38.5673 19.7777 38.5673 17.9983ZM40.3466 17.9983C40.3466 18.799 40.9694 19.4218 41.7701 19.4218C42.5263 19.4218 43.1936 18.799 43.1936 17.9983C43.1936 17.1976 42.5708 16.5748 41.7701 16.5748C40.9694 16.5748 40.3466 17.1976 40.3466 17.9983Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25 14.7955C23.2206 14.7955 21.7972 16.2189 21.7972 17.9983C21.7972 19.7777 23.2206 21.2012 25 21.2012C26.7794 21.2012 28.2028 19.7777 28.2028 17.9983C28.2028 16.2189 26.7794 14.7955 25 14.7955ZM25 19.4218C24.1993 19.4218 23.5765 18.799 23.5765 17.9983C23.5765 17.1976 24.1993 16.5748 25 16.5748C25.8007 16.5748 26.4235 17.1976 26.4235 17.9983C26.4235 18.799 25.7562 19.4218 25 19.4218Z"
        fill="currentColor"
      />
      <path
        d="M11.3876 26.8506C11.3876 28.6195 9.95359 30.0535 8.18471 30.0535C6.41582 30.0535 4.98186 28.6195 4.98186 26.8506C4.98186 25.0817 6.41582 23.6478 8.18471 23.6478C9.95359 23.6478 11.3876 25.0817 11.3876 26.8506Z"
        fill="currentColor"
      />
      <path
        d="M16.4142 30.0535C18.1831 30.0535 19.6171 28.6195 19.6171 26.8506C19.6171 25.0817 18.1831 23.6478 16.4142 23.6478C14.6454 23.6478 13.2114 25.0817 13.2114 26.8506C13.2114 28.6195 14.6454 30.0535 16.4142 30.0535Z"
        fill="currentColor"
      />
      <path
        d="M36.7434 26.8506C36.7434 28.6195 35.3095 30.0535 33.5406 30.0535C31.7717 30.0535 30.3377 28.6195 30.3377 26.8506C30.3377 25.0817 31.7717 23.6478 33.5406 23.6478C35.3095 23.6478 36.7434 25.0817 36.7434 26.8506Z"
        fill="currentColor"
      />
      <path
        d="M41.7701 30.0535C43.539 30.0535 44.973 28.6195 44.973 26.8506C44.973 25.0817 43.539 23.6478 41.7701 23.6478C40.0012 23.6478 38.5673 25.0817 38.5673 26.8506C38.5673 28.6195 40.0012 30.0535 41.7701 30.0535Z"
        fill="currentColor"
      />
      <path
        d="M28.2028 26.8506C28.2028 28.6195 26.7689 30.0535 25 30.0535C23.2311 30.0535 21.7972 28.6195 21.7972 26.8506C21.7972 25.0817 23.2311 23.6478 25 23.6478C26.7689 23.6478 28.2028 25.0817 28.2028 26.8506Z"
        fill="currentColor"
      />
      <path
        d="M40.4358 34.5464C39.8575 34.5464 39.4126 34.057 39.4126 33.5232C39.4126 32.9894 39.902 32.5001 40.4358 32.5001H43.1493C43.7276 32.5001 44.1724 32.9894 44.1724 33.5232C44.1724 34.057 43.6831 34.5464 43.1493 34.5464H40.4358Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.02313 39.2617H48.9769C49.5552 39.2617 50 38.7723 50 38.2385V1.76166C50 1.18336 49.5552 0.738525 48.9769 0.738525H1.02313C0.44484 0.738525 0 1.18336 0 1.76166V38.2385C0 38.7723 0.44484 39.2617 1.02313 39.2617ZM47.9093 37.1709H2.04626V2.7403H47.9093V37.1709Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default BirthcontrolIcon
